module.exports = __webpack_public_path__ + "img/scorecard.5e4b92c9.jpg";